const KindType = Object.freeze({
  facebookPost: 'facebookPost',
  instagramPost: 'instagramPost',
  linkedinPost: 'linkedinPost',
  newsletter: 'newsletter',
  facebookAds: 'facebookAds',
  gmbNewsPost: 'gmbNewsPost',
  gmbProductDescription: 'gmbProductDescription',
  customerMailing: 'customerMailing',
  blogPost: 'blogPost',
  websiteText: 'websiteText',
  interview: 'interview',
})

export const ReadableKindType = Object.freeze({
  facebookPost: 'Facebook Post',
  instagramPost: 'Instagram Post',
  linkedinPost: 'LinkedIn Post',
  newsletter: 'Newsletter',
  facebookAds: 'Facebook Ads',
  gmbNewsPost: 'Google Unternehmensprofil Newspost',
  gmbProductDescription: 'Google Unternehmensprofil Produktbeschreibung',
  customerMailing: 'Kundenanschreiben',
  websiteText: 'Webseiten Text',
  interview: 'Interview',
})

export const KindTypeIcon = Object.freeze({
  facebookPost: '/img/kindTypes/facebook.png',
  instagramPost: '/img/kindTypes/instagram.png',
  linkedinPost: '/img/kindTypes/linkedin.png',
  facebookAds: '/img/kindTypes/facebook.png',
  newsletter: '/img/kindTypes/email.png',
  gmbNewsPost: '/img/kindTypes/google-icon.png',
  gmbProductDescription: '/img/kindTypes/google-icon.png',
  customerMailing: '/img/kindTypes/email.png',
  blogPost: '/img/kindTypes/blog-post.png',
  websiteText: '/img/kindTypes/website-text.png',
  interview: '/img/kindTypes/interview.png',
  all: '/img/kindTypes/settings.png',
})

export const KindName = Object.freeze({
  facebookPost: 'Facebook',
  instagramPost: 'Instagram',
  linkedinPost: 'LinkedIn',
  newsletter: 'Newsletter',
})

export const TypeToKind = Object.freeze({
  FACEBOOK: 'facebookPost',
  INSTAGRAM: 'instagramPost',
  LINKEDIN: 'linkedinPost',
  NEWSLETTER: 'newsletter',
})

export default KindType
